import { makeStyles } from '@material-ui/core/styles';

export const useRatingCompletedResultSelectStyles = makeStyles(theme => ({
  root: {
    minWidth: '8rem',
    display: 'flex',
    '&& .MuiSelect-outlined': {
      display: 'flex',
      alignItems: 'center',
      height: '1.1875rem',
      paddingLeft: 14
    },
    '&& .MuiOutlinedInput-adornedStart': {
      paddingLeft: 0
    },
    '& .Mui-error': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#f44336'
      }
    }
  }
}));
